<template>
  <v-container style="height: 40vh">
    <v-container class="actor-container mb-3" v-for="(actor, index) in actors" :key="index">
      <v-layout row  @click="toggleActor(actor.actor_name)">
        <v-flex md11>
          <span>{{$tf('notification.file.shared.aggregate.body.actor_header', {'name': actor.actor_name, 'action': isCreate? $tf('notification.file.shared.aggregate.created') : $tf('notification.file.shared.aggregate.deleted')})}}</span>
        </v-flex>
        <v-flex md1>
          <v-icon v-if="isActorExpanded(actor.actor_name)" class="clickable">keyboard_arrow_up</v-icon>
          <v-icon v-else class="clickable" >keyboard_arrow_down</v-icon>
        </v-flex>
      </v-layout>
      <v-container v-if="isActorExpanded(actor.actor_name)">
        <div v-for="(parent, parentIndex) in actor.parents" :key="parentIndex">
          <p>{{$tf('notification.file.shared.aggregate.body.parent_header', {'name': parent.parent_name})}} </p>
          <div>
            <div class="d-flex file-container pt-1 pl-4" v-for="(file, fileIndex) in parent.files" :key="fileIndex">
              <div style="width: 75%">
                <v-icon v-if="fileExtension(file.file_name)">description</v-icon>
                <v-icon v-else>folder</v-icon>
                {{ file.file_name }}
              </div>
              <v-icon
                v-if="isCreate"
                class="clickable"
                @click="notificationAction(file.file_url)">
                remove_red_eye
              </v-icon>
            </div>
          </div>
        </div>
      </v-container>
    </v-container>
  </v-container>
</template>

<script>
// @TODO: moving this to a provisionable .html

export default {
  name: 'aggregate-notification',
  props: {
    payload: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      showActor: [],
      showFolder: {}
    }
  },
  mounted () {
    if (this.actors.length > 0) {
      this.showActor.push(this.actors[0].actor_name)
    }
  },
  computed: {
    actors () {
      return this.payload.actors || []
    },
    isCreate () {
      console.log(this.payload)
      return this.payload.notification_name === 'file.shared.new'
    }
  },
  methods: {
    isActorExpanded (name) {
      return this.showActor.includes(name)
    },
    notificationAction (fileUrl) {
      this.$router.push(fileUrl.substring(fileUrl.indexOf('/file')))
      this.$store.dispatch('dialog/closeDialog')
    },
    fileExtension (fileName) {
      return fileName.match(/\.[a-zA-Z]{3}$/g)
    },
    toggleActor (name) {
      if (this.isActorExpanded(name)) {
        const index = this.showActor.indexOf(name)
        this.showActor.splice(index, 1)
      } else {
        this.showActor.push(name)
      }
    }
  }
}
</script>

<style scoped>
.cookie {
    overflow-y: auto;
}
.clickable {
  cursor: pointer;
}
.actor-container {
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}
.collapsed {
  height: 0;
  opacity: 0;
  transition: all .5s cubic-bezier(0, 1, 0, 1);
}
.visible {
  opacity: 1;
  height: 100%;
}
.file-container {
  background: #ffff !important;
  transition: background 0.2s ease;
}
.file-container:hover {
  background: #f5f5f5 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/dialog/types/DialogAggregateNotification.vue